import { hydrateRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RelayEnvironmentProvider } from 'react-relay';
import { createOperationDescriptor, getRequest } from 'relay-runtime';
import serverVars from 'server-vars';

import { IntlProvider } from 'dibs-react-intl';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index.jsx';
import { DibsWeb3ReactProvider } from 'dibs-crypto-utils/exports/DibsWeb3ReactProvider.ts';

import { getRelayEnvironment } from '../utils/relayModernEnvironment.ts';
import { NftHeaderLayout } from '../nftHeader/NftHeaderLayout.tsx';
import { NftMarketLayout, type NftMarketLayoutViewerKey } from './NftMarketLayout.tsx';
import { NftMarketEntryQuery } from './NftMarketEntryQuery.ts';
import { type NftHeaderLayout_viewer$key as NftHeaderLayoutViewer } from '../nftHeader/__generated__/NftHeaderLayout_viewer.graphql.ts';
import { trackPageview } from 'dibs-tracking';

const environment = getRelayEnvironment({
    ...serverVars.get('dbl.relayData'),
});
const variables = serverVars.get('relayVariables');

const operation = createOperationDescriptor(getRequest(NftMarketEntryQuery), variables);
const snapshot = environment.lookup(operation.fragment);
environment.retain(operation);

initializeDBL().then(({ store }: { store: $TSFixMe }) => {
    hydrateRoot(
        document.getElementById('js-root') as HTMLElement,
        <IntlProvider locale={serverVars.get('intlVariables.locale')} disableTranslations>
            <RelayEnvironmentProvider environment={environment}>
                <DibsWeb3ReactProvider>
                    <Provider store={store}>
                        <NftHeaderLayout
                            viewer={snapshot.data.viewer as NftHeaderLayoutViewer}
                            isNftLandingPage
                        >
                            <NftMarketLayout
                                viewer={
                                    // there's no way to narrowly type a snapshot except through assertion
                                    snapshot.data.viewer as NftMarketLayoutViewerKey
                                }
                                startingPage={variables?.page || 1}
                                startingFilters={serverVars.get('activeFilters')}
                            />
                        </NftHeaderLayout>
                    </Provider>
                </DibsWeb3ReactProvider>
            </RelayEnvironmentProvider>
        </IntlProvider>
    );
    trackPageview({
        additional: {
            pageType: 'Other',
            pageSubType: `NFT Marketplace`,
        },
    });
});
